import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Layout from '../components/Layout'
import api from '../services/api'

export default function EmployeeHistoryPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [employee, setEmployee] = useState(null)
  const [contracts, setContracts] = useState([])
  const [evaluations, setEvaluations] = useState([])
  const [loading, setLoading] = useState(true)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchData() }, [id])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [empRes, contractRes, evalRes] = await Promise.all([
        api.get(`/employees/${id}`),
        api.get(`/contracts/by-employee/${id}`),
        api.get(`/evaluations/${id}`)
      ])
      if (empRes.data.success) setEmployee(empRes.data.data)
      if (contractRes.data.success) setContracts(contractRes.data.data)
      if (evalRes.data.success) setEvaluations(evalRes.data.data)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const statusConfig = {
    pending:         { label: 'รอพนักงานเซ็น', color: '#f59e0b', bg: '#fef9c3' },
    signed:          { label: 'รอพยานลงนาม',   color: '#3b82f6', bg: '#eff6ff' },
    witness1_signed: { label: 'รอพยาน 2',       color: '#2563c5', bg: '#eff6ff' },
    approved:        { label: 'รอนายกลงนาม',   color: '#8b5cf6', bg: '#f5f3ff' },
    completed:       { label: 'เสร็จสมบูรณ์',  color: '#22c55e', bg: '#f0fdf4' },
    rejected:        { label: 'ยกเลิก',         color: '#ef4444', bg: '#fef2f2' },
  }

  if (loading) return <Layout><div style={{ textAlign: 'center', padding: '80px', color: '#94a3b8' }}>กำลังโหลด...</div></Layout>
  if (!employee) return <Layout><div style={{ textAlign: 'center', padding: '80px', color: '#94a3b8' }}>ไม่พบข้อมูลพนักงาน</div></Layout>

  const statCards = [
    { label: 'สัญญาทั้งหมด', value: contracts.length, icon: 'ti-files', color: '#075dcc', bg: '#eff6ff' },
    { label: 'เสร็จสมบูรณ์', value: contracts.filter(c => c.status === 'completed').length, icon: 'ti-circle-check', color: '#22c55e', bg: '#f0fdf4' },
    { label: 'ผ่านการประเมิน', value: evaluations.filter(e => e.is_approved).length, icon: 'ti-award', color: '#8b5cf6', bg: '#f5f3ff' },
  ]

  return (
    <Layout>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '24px' }}>
          <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8' }}>
            <i className="ti ti-arrow-left" style={{ fontSize: '22px' }} />
          </button>
          <div>
            <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>ประวัติ {employee.prefix}{employee.first_name} {employee.last_name}</h1>
            <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '2px' }}>{employee.position} — {employee.division_name}</p>
          </div>
        </div>

        {/* ข้อมูลพนักงาน */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '20px 24px', marginBottom: '20px' }}>
          <p style={{ fontSize: '11px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase', marginBottom: '14px' }}>ข้อมูลพนักงาน</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '14px' }}>
            {[
              ['เลขบัตรประชาชน', employee.id_card],
              ['ประเภทพนักงาน', employee.emp_type],
              ['โทรศัพท์', employee.phone || '-'],
              ['Email', employee.email || '-'],
            ].map(([label, value]) => (
              <div key={label}>
                <p style={{ fontSize: '11px', color: '#94a3b8' }}>{label}</p>
                <p style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a', marginTop: '2px' }}>{value}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '14px', marginBottom: '20px' }}>
          {statCards.map((s, i) => (
            <div key={i} style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '18px', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: s.color, borderRadius: '14px 14px 0 0' }} />
              <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                <i className={`ti ${s.icon}`} style={{ fontSize: '18px', color: s.color }} />
              </div>
              <p style={{ fontSize: '26px', fontWeight: '500', color: '#0f172a' }}>{s.value}</p>
              <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{s.label}</p>
            </div>
          ))}
        </div>

        {/* Timeline สัญญา */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden', marginBottom: '20px' }}>
          <div style={{ padding: '16px 24px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ti ti-timeline" style={{ fontSize: '18px', color: '#075dcc' }} />
            <p style={{ fontSize: '14px', fontWeight: '500', color: '#0f172a' }}>Timeline สัญญา</p>
          </div>
          {contracts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8', fontSize: '13px' }}>ไม่มีข้อมูลสัญญา</div>
          ) : (
            <div style={{ padding: '20px 24px' }}>
              {contracts.map((c, i) => {
                const s = c.status === 'ended' ? {label:'สิ้นสุดก่อนกำหนด',color:'#ef4444',bg:'#fef2f2'}
                  : c.status === 'completed' && c.termination_date ? {label:'กำหนดสิ้นสุดล่วงหน้า',color:'#2563eb',bg:'#eff6ff'}
                  : statusConfig[c.status] || { label: c.status, color: '#64748b', bg: '#f1f5f9' }
                return (
                  <div key={c.id} style={{ display: 'flex', gap: '16px', marginBottom: i < contracts.length - 1 ? '20px' : 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
                      <div style={{ width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '500', color: 'white', background: c.status === 'completed' ? '#22c55e' : c.status === 'rejected' ? '#f87171' : '#075dcc' }}>
                        {contracts.length - i}
                      </div>
                      {i < contracts.length - 1 && <div style={{ width: '2px', background: '#e2e8f0', flex: 1, marginTop: '4px', minHeight: '24px' }} />}
                    </div>
                    <div style={{ flex: 1, paddingBottom: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                        <p style={{ fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{c.contract_no}</p>
                        <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: s.color, background: s.bg }}>{s.label}</span>
                        {c.contract_type && (
                          <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', background: '#f1f5f9', color: '#64748b' }}>{c.contract_type}</span>
                        )}
                      </div>
                      <p style={{ fontSize: '12px', color: '#94a3b8' }}>{new Date(c.start_date).toLocaleDateString('th-TH')} — {new Date(c.end_date).toLocaleDateString('th-TH')}</p>
                      <p style={{ fontSize: '12px', color: '#22c55e', fontWeight: '500', marginTop: '2px' }}>{Number(c.total_salary).toLocaleString('th-TH')} บาท/เดือน</p>
                      {c.status === 'completed' && (
                        <button onClick={() => window.open(`/contracts/${c.id}`, '_blank')}
                          style={{ fontSize: '11px', color: '#075dcc', background: 'none', border: 'none', cursor: 'pointer', marginTop: '4px', padding: 0 }}>
                          ดูสัญญา →
                        </button>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {/* ผลประเมิน */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ padding: '16px 24px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="ti ti-chart-bar" style={{ fontSize: '18px', color: '#8b5cf6' }} />
            <p style={{ fontSize: '14px', fontWeight: '500', color: '#0f172a' }}>ผลการประเมิน</p>
          </div>
          {evaluations.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8', fontSize: '13px' }}>ไม่มีข้อมูลการประเมิน</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['ครั้งที่', 'รอบประเมิน', 'คะแนน', 'ผล', 'วันที่'].map(h => (
                      <th key={h} style={{ textAlign: 'left', padding: '10px 16px', fontSize: '11px', color: '#94a3b8', fontWeight: '500' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {evaluations.map((e, i) => (
                    <tr key={e.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                      onMouseEnter={ev => ev.currentTarget.style.background = '#f8fafc'}
                      onMouseLeave={ev => ev.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '10px 16px', fontSize: '13px', color: '#64748b' }}>{i + 1}</td>
                      <td style={{ padding: '10px 16px', fontSize: '13px', color: '#0f172a' }}>{e.period || '-'}</td>
                      <td style={{ padding: '10px 16px', fontSize: '13px', color: '#0f172a' }}>{e.score || '-'}</td>
                      <td style={{ padding: '10px 16px' }}>
                        <span style={{ display: 'inline-flex', padding: '2px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: e.is_approved ? '#22c55e' : '#ef4444', background: e.is_approved ? '#f0fdf4' : '#fef2f2' }}>
                          {e.is_approved ? '✅ ผ่าน' : '❌ ไม่ผ่าน'}
                        </span>
                      </td>
                      <td style={{ padding: '10px 16px', fontSize: '11px', color: '#94a3b8' }}>{e.created_at ? new Date(e.created_at).toLocaleDateString('th-TH') : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}
